import React from 'react';
import TenantPageBase from '../../components/common/page-base/TenantPageBase';

export default function Landing() {
  return (<TenantPageBase />);
}
